exports.slugify = (value, preserveDashes) => {
  if (!value) {
    return value;
  }

  const regex = preserveDashes ? /[^a-z0-9 -]/g : /[^a-z0-9 ]/g;

  // separate path from query parameters, which we don't want to format
  const [path, queryParameters] = value.split('?');

  const slugifiedPath = path
    ?.split('/')
    .map((part) =>
      replaceGermanCharacters(part)
        .normalize('NFD') // split an accented letter in the base letter and the acent
        .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(regex, '') // remove all chars not letters, numbers and spaces (to be replaced)
        .replace(/\s+/g, '-')
    )
    .join('/'); // separator

  return queryParameters
    ? slugifiedPath.concat(`?${queryParameters}`)
    : slugifiedPath;
};

const replaceGermanCharacters = (str) => {
  return str
    .replace(/\u00df/g, 'ss')
    .replace(/\u00e4/g, 'ae')
    .replace(/\u00f6/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\u00c4/g, 'Ae')
    .replace(/\u00d6/g, 'Oe')
    .replace(/\u00dc/g, 'Ue');
};
